module.exports = __webpack_public_path__ + "img/pe.70b54717.svg";